import React, { useEffect, useState, useRef } from 'react';

const SOPEditor: React.FC = () => {
    // Hidden defaults
    const [title] = useState('SOP Document');
    const [content] = useState('');

    const [pdfPath, setPdfPath] = useState<string | null>(null);
    const [file, setFile] = useState<File | null>(null);
    const [message, setMessage] = useState('');
    const fileInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        fetchCurrentSOP();
    }, []);

    const fetchCurrentSOP = async () => {
        try {
            const response = await fetch('/api/sop/current');
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    setPdfPath(data.pdf_path || null);
                }
            }
        } catch (error) {
            console.error('Failed to fetch SOP');
        }
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    };

    const handleSave = async () => {
        if (!file && !pdfPath) {
            setMessage('업로드할 PDF 파일을 선택해주세요.');
            return;
        }

        const token = localStorage.getItem('token');
        const formData = new FormData();
        formData.append('title', title);
        formData.append('content', content);
        if (file) {
            formData.append('file', file);
        } else {
            setMessage('변경 사항이 없습니다.');
            return;
        }

        try {
            const response = await fetch('/api/admin/sop', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: formData
            });

            if (response.ok) {
                setMessage('SOP 파일이 업데이트되었습니다.');
                setFile(null); // Clear selected file after upload
                if (fileInputRef.current) fileInputRef.current.value = '';
                fetchCurrentSOP(); // Refresh to get new pdf path
                setTimeout(() => setMessage(''), 3000);
            } else {
                setMessage('저장 실패');
            }
        } catch (error) {
            setMessage('오류 발생');
        }
    };

    return (
        <div style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px' }}>
            <h2 style={{ marginBottom: '20px' }}>SOP 파일 관리</h2>
            <p style={{ marginBottom: '20px', color: '#666', fontSize: '14px' }}>
                홈페이지 '납품대행-내국물품운영절차(SOP)' 메뉴에서 코드를 입력하면 보여질 PDF 파일을 등록합니다.
            </p>

            <div style={{ marginBottom: '20px', padding: '20px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#f9f9f9', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <label style={{ display: 'block', marginBottom: '15px', fontWeight: 'bold', fontSize: '16px' }}>새로운 PDF 파일 선택</label>
                <input
                    type="file"
                    accept="application/pdf"
                    onChange={handleFileChange}
                    ref={fileInputRef}
                    style={{ marginBottom: '20px' }}
                />

                <button
                    onClick={handleSave}
                    disabled={!file}
                    style={{
                        padding: '12px 30px',
                        backgroundColor: file ? '#007bff' : '#ccc',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: file ? 'pointer' : 'default',
                        fontWeight: 'bold',
                        fontSize: '15px'
                    }}
                >
                    파일 업로드 및 저장
                </button>

                {message && <div style={{ marginTop: '15px', color: message.includes('실패') || message.includes('오류') ? 'red' : 'green', fontWeight: 'bold' }}>{message}</div>}
            </div>

            <div style={{ marginTop: '30px' }}>
                <h3 style={{ fontSize: '16px', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>현재 등록된 SOP 파일</h3>
                {pdfPath ? (
                    <div style={{ border: '1px solid #ccc', height: '600px', backgroundColor: '#eee' }}>
                        <iframe
                            src={pdfPath}
                            width="100%"
                            height="100%"
                            style={{ border: 'none' }}
                            title="SOP PDF Viewer"
                        />
                    </div>
                ) : (
                    <div style={{ padding: '40px', textAlign: 'center', color: '#999', border: '1px dashed #ccc', backgroundColor: '#fafafa' }}>
                        등록된 파일이 없습니다.
                    </div>
                )}
            </div>
        </div>
    );
};

export default SOPEditor;
